import { render } from "./DataTitle.vue?vue&type=template&id=464c00ff&scoped=true"
import script from "./DataTitle.vue?vue&type=script&lang=js"
export * from "./DataTitle.vue?vue&type=script&lang=js"

import "./DataTitle.vue?vue&type=style&index=0&id=464c00ff&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-464c00ff"]])

export default __exports__